import { createSlice } from "@reduxjs/toolkit";
// import { AsyncStorage } from 'AsyncStorage';
// import { AsyncStorageKeys } from "../../utils/constants";

const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        products: [],
        numberOfProducts: 0
    },
    reducers: {
        addItemToCart: (state, action) => {
            const exists = state.products.find(item => item.id == action.payload.id);
            if (exists) {
                const productsIndex = state.products.findIndex(item => item.id == action.payload.id);
                const newQuantity = (exists.cartQuantity + action.payload.cartQuantity);
                state.products[productsIndex] = {
                    ...action.payload,
                    cartQuantity: exists.cartQuantity + action.payload.cartQuantity,
                    cartTotal: !!action.payload.discount && Number(action.payload.discount) > 0 && !!action.payload.priceAfterDiscount ? action.payload.priceAfterDiscount * newQuantity : action.payload.price * newQuantity,
                };
                // AsyncStorage.setItem(AsyncStorageKeys.Cart, JSON.stringify(state.products)).then(result => {
                //     console.log('ok')
                // }).catch(err => {
                //     console.log(err);
                // });
            }else if (!exists) {
                state.products.push(action.payload);
                state.numberOfProducts = state.products.length;
                // AsyncStorage.setItem(AsyncStorageKeys.Cart, JSON.stringify(state.products)).then(result => {
                //     console.log('ok')
                // }).catch(err => {
                //     console.log(err);
                // });
            }
        },
        removeItemFromCart: (state, action) => {
            state.products = state.products.filter(item => item.id != action.payload.id);
            state.numberOfProducts = state.products.length;
            // AsyncStorage.setItem(AsyncStorageKeys.Cart, JSON.stringify(state.products)).then(result => {
            //     console.log('saved');
            // }).catch(err => {
            //     console.log(err)
            // });
        },
        clearCart: (state) => {
            state.products = [];
            state.numberOfProducts = 0;
            // AsyncStorage.removeItem(AsyncStorageKeys.Cart).then(result => {
            //     console.log('ok')
            // }).catch(err => {
            //     console.log(err);
            // })
        },
        refillCart: (state, action) => {
            state.products = action.payload;
            if (action.payload) {
                state.numberOfProducts = action.payload.length;
            }
        }
    }
});

export const { addItemToCart, removeItemFromCart, clearCart, refillCart } = cartSlice.actions;
export default cartSlice.reducer;